import React from 'react';
import { connect } from 'react-redux';
import { Button, message } from 'antd';

import { addMainCategory } from './actions';

import { addMainTitle } from './actions';
import AddCategoryModal from './add-category-modal';

class AddMainCategoryButton extends React.Component{

	render(){
		return (
			<div>
				<Button onClick={this.handleOpenModal} shape="circle" icon="plus-circle" />
				
				<AddCategoryModal
					title="Add a main category"

					handleCloseModal={this.handleCloseModal}
					handleConfirm={this.handleConfirmTitle}

					onChange={this.handleOnChange}
					onErrorHandler={this.handleError}
					value={this.state.mainCategoryTitle}

					visible={this.state.openModal}/>
			</div>
		)
	}

	state = {
		openModal: false,
		mainCategoryTitle: ""
	}

	handleCloseModal = () => {
		this.setState({
			mainCategoryTitle:'',
			openModal: false
		})
	}

	handleConfirmTitle = () => {

		const { mainCategoryTitle } = this.state;

		if(!mainCategoryTitle){
			return message.error("Empty Field is not allowed!");
		}

		if(this.state.error){
			message.error(`Can't save ${mainCategoryTitle}`);
		} else {
			addMainTitle(mainCategoryTitle)
				.then( res => {
					message.success(`${mainCategoryTitle} was added successfully!`);
					this.handleCloseModal();
					this.props.dispatch(addMainCategory(res.data));
				})
				.catch( err => {
					message.error(err.response.data.message);
				})
		}
	}

	handleError = (error) => {
		this.setState({
			error
		})
	}

	handleOnChange = (e) => {
		this.setState({
			mainCategoryTitle: e.target.value
		})
	}

	handleOpenModal = () => {
		this.setState({
			openModal: true
		})
	}

}

export default connect()(AddMainCategoryButton);


// WEBPACK FOOTER //
// ./src/components/category/add-main-category-button.js